import request from 'services/request';

export async function getAccountStatementPdf({ params, cancelToken }) {
  return request('/AccountStatement/Api/v1/Files', {
    method: 'GET',
    params,
    cancelToken,
  });
}
